import { Box, Container, styled, Typography } from "@mui/material";
import React from "react";
import GlobalButton from "../../../components/CustomButton";
import { allImages } from "../../../assets";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#000000",
  padding: "50px 0px",
  color: "#ffffff",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "35px 0px",
  },

  "& .lpl_ne_pr": {
    fontWeight: 700,
    fontSize: "2.5rem",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },

  "& .lpl_ne_curve": {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
  },
}));

function NextBussiness() {
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <img
        src={allImages.landingCurveLine}
        alt={"curve-line"}
        className="lpl_ne_curve"
      />
      <Container maxWidth={"lg"} sx={{ position: "relative", zIndex: 999 }}>
        <Typography variant="h1" className="lpl_ne_pr">
          Ready for your next business?
        </Typography>
        <Typography variant="h6" fontWeight={300}>
          Sit elit feugiat turpis sed integer integer accumsan turpis.
        </Typography>
        <GlobalButton
          btnText={"Request Demo"}
          styleProps={{ width: 200, marginTop: "3rem" }}
        />
      </Container>
    </MainView>
  );
}

export default NextBussiness;
